export default __webpack_public_path__ + "static/media/referral-reward-vi.c81fc73d.svg";